module.exports = __webpack_public_path__ + "static/media/fondmarin.a8ff4ea2.jpg";